<style lang="stylus" scoped>
    .ed-progress-bar {
        width: 100%;
        height: 4px;
        background: rgba(255, 255, 255, 0.12);
        position: relative;
        border-radius 8px;
        .progress {
            border-radius 8px;
            height: 100%;
            background-color: var(--themeColor);
            position: absolute;
            transition: width ease-in-out;
        }
    }
</style>

<template>
    <div class="ed-progress-bar">
        <div class="progress" ref="edProgress"></div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import ProgressBar from "./ProgressBar";

    @Component
    export default class ProgressBarComp extends Vue {
        progress: ProgressBar;

        pause() {
            if (this.progress) {
                this.progress.pause();
            }
        }
        resume() {
            if (this.progress) {
                this.progress.resume();
            }
        }
        finish() {
            if (this.progress) {
                this.progress.finish();
            }
        }

        mounted() {
            this.progress = new ProgressBar({
                ele: this.$refs.edProgress as HTMLElement,
                totalTime: 2,
                stage1Time: 0.5,
                stage2Time: 2,
            });
        }
        beforeDestroy() {
            this.progress = null;
        }
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
